import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=8e744f9e&scoped=true"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=8e744f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e744f9e",
  null
  
)

export default component.exports